import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Auth } from 'aws-amplify';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaxterAuthenticationService } from '@baxter-jenkins/authenticator';
import { AngularCommonService } from '../../service/angular-common.service';
import { VerifySoftwareTokenCommand } from '@clearing-hub/command';
import { AuthenticatorConfig } from '@baxter-jenkins/authenticator/lib/model/AuthenticatorConfig';

@Component({
  selector: 'baxter-library-security-settings',
  templateUrl: './security-settings.component.html',
  styleUrl: './security-settings.component.scss',
})
export class SecuritySettingsComponent implements OnInit {

  @Input()
  includeModal: boolean;

  @Input()
  modalRef: any;

  @Input()
  toastr: any;

  @Input()
  navigateAfterLogout: string;

  @Output()
  cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup;

  mfaFormGroup: FormGroup;

  user: any;

  setAuthenticatorApp: boolean;
  associateResp: any;
  qrCode: string;

  authenticatorConfig: AuthenticatorConfig;
  submitted: boolean;

  constructor(private readonly fb: FormBuilder,
              private readonly angularCommonService: AngularCommonService) {
  }

  async ngOnInit(): Promise<void> {
    this.authenticatorConfig = BaxterAuthenticationService.authenticatorConfig;
    const validations = BaxterAuthenticationService.getPasswordValidations();
    this.form = this.fb.group({
        oldPassword: new FormControl('', Validators.required),
        newPassword: new FormControl('', validations),
        newPasswordconf: new FormControl('', validations)
      }, {
        validators: [SecuritySettingsComponent.isPasswordsMatchedValidator.bind(this)]
      }
    );

    // await this.setUser();
    this.mfaFormGroup = this.fb.group({
      code: new FormControl(null, Validators.required)
    });
    await this.refreshUserData();
  }

  async refreshUserData() {
    try {
      this.user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    } catch (error) {
      console.error('Error refreshing user data', error);
    }
  }


  static isPasswordsMatchedValidator(form: FormGroup) {
    const password = form.controls['newPassword'].value;
    const repeatPassword = form.controls['newPasswordconf'].value;
    if (repeatPassword !== password) {
      return {
        passwordsMatched: true
      };
    }
    return null;
  }

  async submit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    try {
      const user = await Auth.currentAuthenticatedUser();
      const data = await Auth.changePassword(user, this.form.value.oldPassword, this.form.value.newPassword);
      this.toastr.success('Password successfully changed');
      this.cancelEvent.emit();
    } catch(err) {
      console.log(err);
      this.toastr.error(err.message);
    }
  }

  clearCognitoLocalStorage() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('CognitoIdentityServiceProvider')) {
        localStorage.removeItem(key);
      }
    });
  }


  async setUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      this.user = user;
      return user;
    } catch (error) {
      console.error('Error fetching authenticated user', error);
      return null;
    }
  }

  enableSetAuthenticatorApp() {
    this.angularCommonService.associateSoftwareToken().subscribe(async (resp) => {
      this.associateResp = resp;
      this.setAuthenticatorApp = true;
      const user = await Auth.currentAuthenticatedUser();
      const issuer = 'FXCH';
      this.qrCode = `otpauth://totp/${encodeURIComponent(issuer + ':' + user.attributes.email)}?secret=${resp.secretCode}&issuer=${encodeURIComponent(issuer)}`;
    });
  }

  verifySoftwareToken() {
    if (this.mfaFormGroup.invalid) {
      return;
    }
    const command: VerifySoftwareTokenCommand = {
      code: this.mfaFormGroup.get('code').value,
      token: this.associateResp.token,
      session: this.associateResp.session
    };
    this.angularCommonService.verifySoftwareToken(command).subscribe(async (resp) => {
      this.toastr.success('Software token successfully added to your account.');
      await this.refreshUserData();
      this.setAuthenticatorApp = false;
      this.associateResp = null;
      this.qrCode = null;
    });
  }

  cancel() {
    this.cancelEvent.emit();
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
}
